import React, { memo } from 'react';
import SimulationChart from './SimulationChart/SimulationChart';
import styles from './simulation.module.scss';
import StrategiesList from './StrategiesList/StrategiesList';

const Simulation = () => {
  return (
    <div className={styles.container}>
      <SimulationChart />
      <hr className={styles.divider} />
      <StrategiesList />
    </div>
  );
};

export default memo(Simulation);
